import classNames from 'classnames';
import { UI_Link } from 'ui/components/1-atoms/Action/Link/Link';
import styles from './LocalNavigation.module.scss';
import { NavigationItemProps } from 'ui/components/3-organisms/Navigation/NavigationList/NavigationList';
import IconMinus from 'ui/icons/icon_minus.svg';
import IconPlus from 'ui/icons/icon_plus.svg';
import { UI_Icon } from 'ui/components/1-atoms/Media/Icon/Icon';

export interface LocalNavigationProps {
	className?: string;
	heading?: string;
	localNavigationItems: NavigationItemProps[];
}

const descendantsContainCurrentPage = (descendants: NavigationItemProps[]): boolean | undefined => {
	if (!descendants) return undefined;
	return descendants.some((item) => item.current || (item.descendants && descendantsContainCurrentPage(item.descendants)));
};

const getLevelClass = (level: number) => {
	if (level === 1) return styles.LocalNavigation_items___children;
	if (level === 2) return styles.LocalNavigation_items___grandChildren;
	if (level === 3) return styles.LocalNavigation_items___greatGrandChildren;
	if (level >= 4) return styles.LocalNavigation_items___greatGreatGrandChildren;
	return undefined;
};

const renderNavItems = (items: NavigationItemProps[], level = 0) => {
	if (!items || items.length < 1) return null;
	return (
		<ul className={classNames(styles.LocalNavigation_items, getLevelClass(level))}>
			{items.map((item: NavigationItemProps, index) => {
				const isExpanded = item.current || descendantsContainCurrentPage(item.descendants);
				const hasChildren = item.descendants && item.descendants.length > 0;
				return (
					<li key={index} className={classNames(styles.LocalNavigation_item, item.current && styles.LocalNavigation_item___current)}>
						<UI_Link
							url={item.url}
							className={styles.LocalNavigation_itemLink}
							ariaCurrent={item.current}
							ariaExpanded={hasChildren && isExpanded ? true : undefined}
							ariaControls={item.id + '-list'}
						>
							{hasChildren && !isExpanded && (
								<UI_Icon className={classNames(styles.LocalNavigation_icon, styles.LocalNavigation_icon___expand)} size="sm">
									<IconPlus />
								</UI_Icon>
							)}
							{hasChildren && isExpanded && (
								<UI_Icon className={classNames(styles.LocalNavigation_icon, styles.LocalNavigation_icon___close)} size="sm">
									<IconMinus />
								</UI_Icon>
							)}
							{(item.title || item.name) && <span>{item.title || item.name}</span>}
						</UI_Link>
						{hasChildren && isExpanded && renderNavItems(item.descendants, level + 1)}
					</li>
				);
			})}
		</ul>
	);
};

export const UI_LocalNavigation = ({ className, heading, localNavigationItems }: LocalNavigationProps) => {
	if (!localNavigationItems || localNavigationItems.length < 1) return null;
	return (
		<nav className={classNames(styles.LocalNavigation, className)}>
			<h2 className={styles.LocalNavigation_heading}>{heading}</h2>
			{renderNavItems(localNavigationItems)}
		</nav>
	);
};
